import { call, put } from "redux-saga/effects";
import * as actions from "../state/DfdActions";
import {
  AuthentificationApi,
  getCategorieApi,
  searchDemandesApi,
  getEtatsApi,
  getGroupesContingentApi,
  getNomenclaturesApi,
  getImportateursApi,
  getPaysOrigineApi,
  downloadDemandApi,
  getDfdMarchandisesApi,
  getDfdDocumentsApi,
  getDfdDecisionsApi,
  getDfdByIdApi,
  getHistoriqueApi,
  downloadDemandDocumentApi,
  getDecisionTypeApi,
  getUniteDouniereApi,
  getUniteCompApi,
  getDepartmentsApi,
  transferDfdApi,
  DecisionMceDfdApi,
  DecisionDepDfdApi,
  getNomenclaturesGroupeApi,
  getSelectedDepartmentsApi,
  getFixedDfdDecisionApi,
  getDFDColumnsDensityStateApi,
  postChangePasswordApi,
  fetchKpiDfdApi,
  updateDfdDateFinValiditeApi,
  registerMFAApi,
  sendOtpMailApi,
} from "../../../common/services/api/DfdApi";
import { getAuth } from "../../../common/utils/FunctionsUtils";

export function* searchDemandesSaga(payload) {
  try {
    const response = yield call(searchDemandesApi, payload);
    yield put(actions.searchDemandesSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.searchDemandesFailure(err));
  }
}

export function* searchAllDemandesSaga(payload) {
  try {
    payload = {
      ...payload,
      searchObject: {
        ...payload.searchObject,
        pagination: {
          ...payload.searchObject.pagination,
          pageSize: 1000,
        },
      },
    };

    const response = yield call(searchDemandesApi, payload);
    yield put(actions.searchAllDemandesSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.searchAllDemandesFailure(err));
  }
}

export function* fetchHistoriqueSaga(id) {
  try {
    const response = yield call(getHistoriqueApi, id);
    yield put(actions.fetchHistoriqueSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.fetchHistoriqueFailure(err));
  }
}

export function* getCategoriesSaga() {
  try {
    const response = yield call(getCategorieApi);
    yield put(actions.getCategoriesSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getCategoriesFailure(err));
  }
}

export function* getEtatsSaga() {
  try {
    const Authority = getAuth();
    const response = yield call(getEtatsApi);
    let etats = response.data;

    const desiredDescriptions = [
      "Soumise pour visa MCE",
      "Soumise pour modification MCE",
      "Rejetée",
      "Clôturée",
      "Refus temporaire MCE",
      "Acceptée ADII",
      "Rejetée ADII",
      "Avis total",
    ];

    etats = etats.filter((etat) =>
      desiredDescriptions.includes(etat.description)
    );

    const AT = {
      id: 15,
      code: "AT",
      description: "Avis total",
      created_dt: "2021-02-18T11:34:08.000+00:00",
    };

    const TRN = {
      id: 32,
      code: "TRN",
      description: "Soumise pour visa (avec transfert)",
      created_dt: "2021-02-18T11:34:08.000+00:00",
    };

    etats.push(TRN);
    if (
      Authority?.roles?.includes("ROLE_VUPORTUARIA_MCE") &&
      !Authority?.roles?.includes("ROLE_VUPORTUARIA_OTHER_DEPARTMENT")
    ) {
      etats.push(AT);
    }

    etats = etats.map((etat) => ({
      ...etat,
      description: `(${etat.code}) ${etat.description}`,
    }));

    yield put(actions.getEtatsSuccess(etats));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getEtatsFailure(err));
  }
}

export function* getPaysOrigineSaga() {
  try {
    const response = yield call(getPaysOrigineApi);
    yield put(actions.getPaysOrigineSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getPaysOrigineFailure(err));
  }
}

export function* getGroupesContingentSaga(payload) {
  try {
    const response = yield call(getGroupesContingentApi, payload);
    yield put(actions.getGroupesContingentSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getGroupesContingentFailure(err));
  }
}

export function* getNomenclaturesSaga(payload) {
  try {
    const response = yield call(getNomenclaturesApi, payload);
    yield put(actions.getNomenclaturesSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getNomenclaturesFailure(err));
  }
}

export function* getImportateursSaga(payload) {
  try {
    const response = yield call(getImportateursApi, payload);
    yield put(actions.getImportateursSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getImportateursFailure(err));
  }
}

export function* getDfdByIdSaga(id) {
  try {
    const response = yield call(getDfdByIdApi, id);
    yield put(actions.getDfdSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getDfdFailure(err));
  }
}

export function* getDfdDecisionsSaga(id) {
  try {
    const response = yield call(getDfdDecisionsApi, id);
    yield put(actions.getDfdDecisionsSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getDfdDecisionsFailure(err));
  }
}

export function* getDfdDocumentsSaga(id) {
  try {
    const response = yield call(getDfdDocumentsApi, id);
    yield put(actions.getDfdDocumentsSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getDfdDocumentsFailure(err));
  }
}

export function* registerMFASaga(payload) {
  try {
    const response = yield call(registerMFAApi, payload);
    yield put(actions.registerMFASuccess(response?.data));
  } catch (error) {
    yield put(actions.registerMFAFailure(error));
  }
}

export function* sendOtpMailSaga(payload) {
  try {
    const response = yield call(sendOtpMailApi, payload);
    yield put(actions.sendOtpMailSuccess(response?.data));
  } catch (error) {
    yield put(actions.sendOtpMailFailure(error));
  }
}


export function* getDfdMarchandisesSaga(id) {
  try {
    const response = yield call(getDfdMarchandisesApi, id);
    yield put(actions.getDfdMarchandisesSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getDfdMarchandisesFailure(err));
  }
}

export function* downloadDocumentSaga(id) {
  try {
    const response = yield call(downloadDemandApi, id);
    yield put(actions.downloadDemandeSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.downloadDemandeFailure(err));
  }
}

export function* downloadDemandeDocument(id) {
  try {
    const response = yield call(downloadDemandDocumentApi, id);
    const data = response?.data || "DOWNLOAD";
    yield put(actions.downloadDemandeDocumentSuccess(data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.downloadDemandeDocumentFailure(err));
  }
}

export function* getDecisionTypeSaga() {
  try {
    const response = yield call(getDecisionTypeApi);
    yield put(actions.getDecisionTypeSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getDecisionTypeFailure(err));
  }
}

export function* getUniteDouniereSaga() {
  try {
    const response = yield call(getUniteDouniereApi);
    yield put(actions.getUniteDouniereSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getUniteDouniereFailure(err));
  }
}

export function* getUniteCompSaga() {
  try {
    const response = yield call(getUniteCompApi);
    yield put(actions.getUniteCompSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getUniteCompFailure(err));
  }
}

export function* getDepartmentsSaga() {
  try {
    const response = yield call(getDepartmentsApi);
    yield put(actions.getDepartmentsSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getDepartmentsFailure(err));
  }
}

export function* DecisionMceDfdSaga(payload) {
  try {
    const response = yield call(DecisionMceDfdApi, payload);
    yield put(actions.DecisionMceDfdSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.DecisionMceDfdFailure(err));
  }
}

export function* DecisionDepDfdSaga(payload) {
  try {
    const response = yield call(DecisionDepDfdApi, payload);
    yield put(actions.DecisionDepDfdSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.DecisionDepDfdFailure(err));
  }
}

export function* transferDfdSaga(payload) {
  try {
    const response = yield call(transferDfdApi, payload);
    yield put(actions.transferDfdSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.transferDfdFailure(err));
  }
}

export function* getNomenclaturesGroupeSaga(payload) {
  try {
    const response = yield call(getNomenclaturesGroupeApi, payload);
    const data = response?.data?.categoryNomenclature?.endDate || null;
    yield put(actions.getNomenclaturesGroupeSuccess(data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getNomenclaturesGroupeFailure(err));
  }
}

export function* getSelectedDepartmentsSaga(payload) {
  try {
    const response = yield call(getSelectedDepartmentsApi, payload);
    yield put(actions.getSelectedDepartmentsSuccess(response?.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getSelectedDepartmentsFailure(err));
  }
}

export function* getFixedDfdDecisionSaga(payload) {
  try {
    const response = yield call(getFixedDfdDecisionApi, payload);

    let fixedDecision = null;
    let description = response?.data?.description;

    if (description === "Refus temporaire") {
      fixedDecision = 3;
    } else if (description === "Refuser") {
      fixedDecision = 2;
    }

    yield put(actions.getFixedDfdDecisionSuccess(fixedDecision));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getFixedDfdDecisionFailure(err));
  }
}

export function* authenticateSaga(payload) {
  try {
    const response = yield call(AuthentificationApi, payload);
    yield put(actions.authenticateSuccess(response?.data));
  } catch (error) {
    yield put(actions.authenticateFailure(error));
  }
}

export function* getDFDColumnsDensityStateSaga() {
  try {
    const response = yield call(getDFDColumnsDensityStateApi);
    const { id, activatedField, density } = response.data;
    if (response.data && response.data !== null && id !== null) {
      let activatedFieldsArray = [""];
      if (activatedField !== null) {
        activatedFieldsArray = activatedField.split(",");
      }
      const allFields = {
        categorie: false,
        importateur: false,
        dateSoumission: false,
        avis: false,
        bureauD: false,
        marchandise: false,
        nomenclature: false,
        numDecision: false,
        etat: false,
      };

      activatedFieldsArray.forEach((field) => {
        if (allFields.hasOwnProperty(field)) {
          allFields[field] = true;
        }
      });

      const newData = {
        id: id,
        columnsState: allFields,
        density: density || "standard",
      };

      yield put(actions.getDFDColumnsDensityStateSuccess(newData));
    } else {
      const newData = null;
      yield put(actions.getDFDColumnsDensityStateSuccess(newData));
    }
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getDFDColumnsDensityStateFailure(err));
  }
}

export function* postChangePasswordSaga(payload) {
  const response = yield call(postChangePasswordApi, payload);
  if (response.success) {
    yield put(actions.postChangePasswordSuccess(response?.data?.message));
  } else {
    yield put(actions.postChangePasswordFailure(response?.error?.message));
  }
}

export function* fetchKpiDfdSaga(payload) {
  try {
    const response = yield call(fetchKpiDfdApi, payload);
    yield put(actions.fetchKpiDfdSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.fetchKpiDfdFailure(err));
  }
}

export function* updateDfdDateFinValiditeSaga(payload) {
  try {
    const response = yield call(updateDfdDateFinValiditeApi, payload);
    yield put(actions.updateDfdDateFinValiditeSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.updateDfdDateFinValiditeFailure(err));
  }
}
